// Key code
export const ENTER_KEY = 13;

// Collection path
export const ROOMS_PATH = 'rooms';
export const USERS_PATH = 'users';
export const FRIENDS_PATH = 'friends';
export const PLAYGROUNDS_PATH = 'playgrounds';
export const HISTORIES_PATH = 'histories';

// Local storage keys
export const USER_KEY = 'user';

// Room status
export const ROOM_WAITING = 'waiting';
export const ROOM_READY = 'ready';
export const ROOM_STARTING = 'starting';
